import { Button, DatePicker, Form, Input, Modal, Select } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { loadAllDesignation } from "../../../redux/rtk/features/designation/designationSlice";
import { loadSingleStaff } from "../../../redux/rtk/features/user/userSlice";
import { addDesHistory } from "../../designationHistory/designationHistoryApis";

const DesignationAddSinglePopup = ({ list, setLoading, initialData }) => {
  const [form] = Form.useForm();

  // Use designations from Redux store
  const designations = useSelector((state) => state.designations.list);

  const user_id = useParams("id");
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [DesignationId, setDesignationId] = useState(initialData?.DesignationId || "");
  const [EffectedFrom, setEffectedFrom] = useState(
    initialData?.EffectedFrom ? dayjs(initialData.EffectedFrom) : null
  );
  const [EffectedTo, setEffectedTo] = useState(
    initialData?.EffectedTo ? dayjs(initialData.EffectedTo) : null
  );

  useEffect(() => {
    dispatch(loadAllDesignation());
    if (initialData) {
      form.setFieldsValue({
        DesignationId: initialData.DesignationId,
        EffectedFrom: initialData.EffectedFrom ? dayjs(initialData.EffectedFrom) : null,
        EffectedTo: initialData.EffectedTo ? dayjs(initialData.EffectedTo) : null,
      });
      setIsModalOpen(true); // Auto-open modal if initialData is provided
    }
  }, [dispatch, initialData, form]);

  const onFinish = async (values) => {
    setLoader(true);
    setLoading(true);
    const infodata = {
      ...values,
      DesignationHistoryId: 0,
      EmployeeId: parseInt(user_id.id),
      DesignationId: parseInt(DesignationId),
      EffectedFrom: EffectedFrom ? dayjs(EffectedFrom).format("YYYY-MM-DD") : null,
      EffectedTo: EffectedTo ? dayjs(EffectedTo).format("YYYY-MM-DD") : null,
      DataStatus: 1,
    };

    const resp = await addDesHistory(infodata);
    if (resp.message === "success") {
      setLoader(false);
      dispatch(loadSingleStaff(user_id.id));
      setIsModalOpen(false);
      setLoading(false);
      form.resetFields();
    } else {
      setLoader(false);
      setLoading(false);
      toast.error(resp.message || "Failed to add designation");
    }
  };

  const onFinishFailed = (errorInfo) => {
    toast.warning("Failed at adding designation");
    setLoader(false);
    setLoading(false);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setEffectedFrom(null);
    setEffectedTo(null);
    setIsModalOpen(false);
    setLoader(false);
    setLoading(false);
    form.resetFields();
  };

  const handleCancel = () => {
    setEffectedFrom(null);
    setEffectedTo(null);
    setIsModalOpen(false);
    setLoader(false);
    setLoading(false);
    form.resetFields();
  };

  return (
    <>
      <div className="text-center">
        <Button type="primary" onClick={showModal}>
          Add New Designation
        </Button>
      </div>
      <Modal
        title={`Add Designation`}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form
          form={form}
          style={{ marginBottom: "100px" }}
          eventKey="department-form"
          name="basic"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 16 }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <div>
            <Form.Item
              style={{ marginBottom: "10px" }}
              label="Designation"
              name="DesignationId"
              rules={[{ required: true, message: "Please input your Designation!" }]}
            >
              <Select
                showSearch
                loading={!designations}
                placeholder="Select Designation"
                onChange={(value) => setDesignationId(value)}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {designations?.map((item) => (
                  <Select.Option key={item.DesignationId} value={item.DesignationId}>
                    {item.DesignationName || ""}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              style={{ marginBottom: "10px" }}
              label="Effected From"
              name="EffectedFrom"
              rules={[{ required: true, message: "Please input your start date!" }]}
            >
              <DatePicker onChange={(date) => setEffectedFrom(date)} />
            </Form.Item>

            <Form.Item
              style={{ marginBottom: "10px" }}
              label="Effected To"
              name="EffectedTo"
            >
              <DatePicker onChange={(date) => setEffectedTo(date)} />
            </Form.Item>

            <Form.Item
              style={{ marginBottom: "20px" }}
              wrapperCol={{ offset: 6, span: 12 }}
            >
              <Button
                onClick={() => setLoader(true)}
                type="primary"
                size="small"
                htmlType="submit"
                block
                loading={loader}
              >
                Add Now
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default DesignationAddSinglePopup;